import React from 'react';
import Sidebar from './Sidebar';

const SidebarWrapper = () => {
    return (
        <div className='sidebar__wrapper'>
            <Sidebar />
        </div>
    );
};

export default SidebarWrapper;
